import { defineStore } from 'pinia'
import { useAuthStore } from '@/stores/authStore'
import { getRuntimeConfig } from '@erebus/runtime-config'
import { onAuthFailure } from '@erebus/http'
import router from '@/router'

export const useAppStore = defineStore('app', () => {

  const bootstrap = async () => {
    const authStore = useAuthStore();
    await authStore.bootstrap();

    if (getRuntimeConfig().useCookieAuth) {
      onAuthFailure(() => { void router.push({ name: 'logout' }) })
    }
  }

  return { bootstrap }
})
